import React from "react";
import MenuSelect from "../ui/MenuSelect";
import { TENDON_TYPE_OPTIONS } from "./tendonPanelConstants";

const TendonTypeSection = ({ tendon, onChangeTendonType }) => (
  <div className="space-y-1">
    <div className="text-xs uppercase tracking-wider panel-text-helper">Tendon Type</div>
    <MenuSelect
      size="compact"
      value={tendon.kind === "spatial" ? "spatial" : "fixed"}
      onChange={onChangeTendonType}
      options={TENDON_TYPE_OPTIONS}
      triggerClassName="w-full"
      contentClassName="max-h-[min(220px,50vh)]"
      aria-label="Tendon type"
    />
  </div>
);

export default TendonTypeSection;
